module.exports = __webpack_public_path__ + "img/main_bg.f383741d.jpg";